<app-image-section-card [title]="item().name | translate"
                        [subTitle]="item().description | translate"
                        (click)="onOpenSection()"
                        [showArrow]="true"
                        size="medium">
    <app-service-box-icon [size]="'small'"
                          image
                          [key]="item().id"></app-service-box-icon>
</app-image-section-card>
